import {Component, OnInit, HostBinding, Output, EventEmitter, Input} from '@angular/core';
import {STATE_NAMES} from '../../../common';
import {
    StorageService,
    RoutingService,
    ChatService,
    WebsocketService,
    AppToastrService,
    EventsService
} from '../../../services';
import {StateService, TransitionService} from '@uirouter/angular';
import {DayEvents, Message} from '../../../models';
import * as moment from 'moment';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.html'
})

export class GlobalNavigationComponent implements OnInit {
    // transPrefix = 'Navigation.';
    links: any[];
    homeState: string;
    currentState: string;
    isAdmin: any;
    dayEvents: any;
    clientID: number;
    showCounterEvents: boolean;
    @Input() collapsed: boolean;
    @Output() menuToggle = new EventEmitter();
    @Output() openElement = new EventEmitter();

    @HostBinding('class.mobile-opened') isMenuOpened = false;

    constructor(private routingService: RoutingService,
                private stateService: StateService,
                private toast: AppToastrService,
                private websocket: WebsocketService,
                private eventsService: EventsService,
                private transitionService: TransitionService,
                private chat: ChatService,
                public storage: StorageService) {
        this.clientID = this.storage.userId;
        this.currentState = stateService.current.name;
        this.showCounterEvents = this.currentState !== 'app.events';
        transitionService.onSuccess({}, transition => {
            this.currentState = transition.router.stateService.current.name;
            if (!this.showCounterEvents) {
                this.storage.travelCounter = 0;
            }
            this.showCounterEvents = this.currentState !== 'app.events';
            if (!this.showCounterEvents) {
                this.storage.travelCounter = 0;
            }
        });
    }

    ngOnInit() {
        Notification.requestPermission();
        this.countChatMessage();
        this.isAdmin = false;
        this.getListMenu();
        this.subscribeToWS();
        if(this.storage.travelCounter === null) {
            this.init();
        }
    }

    subscribeToWS() {
        this.websocket.new_event(this.clientID).subscribe((data) => {
            this.storage.travelCounter = this.storage.travelCounter + 1;
        });
    }

    async init() {
        await this.getDayEvents();
    }

    getDayEvents() {
        return new Promise((resolve, reject) => {
            this.eventsService.getUnshowedEvents().subscribe((res) => {
                if (res) {
                    this.storage.travelCounter = res.length;
                    resolve(true);
                }
            }, (err) => {
                console.log('err', err);
                reject(true);
            });
        });
    }

    countChatMessage() {
        this.chat.getUnreadMessages(this.clientID).subscribe(res => this.storage.chatCounter = res);
        this.websocket.new_event(this.clientID).subscribe(event => {
            const eventN = new DayEvents().setFromApiModel({events: [event]}).events[0];
            console.log(eventN);
            const notification = new Notification('Фабрика Туризма - Новое сообщение', {
                body: eventN.timeString + ' - ' + eventN.name + '\nНажмите здесь чтобы открыть приложение\n' + moment(eventN.date).format('DD-MM-yyyy'),
                icon: 'https://' + location.host + '/favicon.ico'
            });
            notification.onclick = (e) => {
                e.preventDefault();
                window.open(location.protocol + '//' + location.host + '/#/events', '_blank');
            };
        }, err => {
            console.log(err);
            this.toast.showToastFromError(err);
        });
        this.websocket.new_message(this.clientID).subscribe(
            msg => {
                const msgN = new Message().setFromApiModel(msg);
                if (msgN.reply_to !== this.clientID && location.href.indexOf('chat') === -1 && msgN.message) {
                    const notification = new Notification('Фабрика Туризма - Новое сообщение', {
                        body: msgN.agent_json.f_name + ' ' + msgN.agent_json.l_name + '\n' + msgN.message + '\n' + moment(msgN.send_at).format('DD-MM-yyyy'),
                        icon: 'https://' + location.host + '/favicon.ico'
                    });
                    notification.onclick = (event) => {
                        event.preventDefault();
                        window.open(location.protocol + '//' + location.host + '/#/chat', '_blank');
                    };
                }
                if (msgN.reply_to !== this.clientID) {
                    this.storage.chatCounter += 1;
                }
            },
            err => {
                console.log(err);
            }
        );
    }

    getListMenu() {
        this.links = [
            {
                state: STATE_NAMES.main,
                text: 'Главная',
                className: 'lnr-home',
                states: [],
                visible: true
            },
            {
                state: STATE_NAMES.travels,
                text: 'Путешествия',
                className: 'lnr-map',
                states: [],
                visible: true
            },
            {
                state: STATE_NAMES.events,
                text: 'События',
                className: 'lnr-calendar-full',
                states: [],
                visible: true
            },
            {
                state: STATE_NAMES.chat,
                text: 'Чат',
                className: 'lnr-bubble',
                states: [],
                visible: true
            },

        ];

    }

    onMenuToggle() {
        this.menuToggle.emit();
        if (!this.collapsed) {
            this.links.forEach(item => {
                item.isSubOpened = false;
            });
        }
    }

    toggleSubMenu(link: any) {
        if (this.collapsed) {
            this.menuToggle.emit('open');
            setTimeout(() => {
                link.isSubOpened = true;
            }, 100);
        } else {
            link.isSubOpened = !link.isSubOpened;
        }
        this.isMenuOpened = true;
        // link.isSubOpened = this.collapsed ? true : !link.isSubOpened;
    }

    onItemClick() {

    }
}
